import { Component } from '@angular/core';
import { HybridToolsService } from '../../services/hybrid-tools.service';

@Component({
    selector: 'cat-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    constructor(public hybridToolsService: HybridToolsService) {}
}
